import apiClient from './client';

export type PartnerPlacement = 'landing' | 'dashboard' | 'footer' | 'all';

export interface Partner {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  url: string;
  logo_url: string | null;
  cta_label: string | null;
  placement: PartnerPlacement;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreatePartnerPayload {
  slug: string;
  name: string;
  description?: string;
  url: string;
  logo_url?: string;
  cta_label?: string;
  placement?: PartnerPlacement;
  is_active?: boolean;
}

export interface UpdatePartnerPayload {
  name?: string;
  description?: string;
  url?: string;
  logo_url?: string;
  cta_label?: string;
  placement?: PartnerPlacement;
  is_active?: boolean;
}

export interface PartnerStatsParams {
  from?: string;
  to?: string;
  groupBy?: 'day' | 'week' | 'month';
}

export interface PartnerStats {
  total_clicks: number;
  unique_users: number;
  unique_visitors: number;
  by_placement: Array<{ placement: PartnerPlacement; clicks: number }>;
  timeseries: Array<{ date: string; clicks: number }>;
}

export const partnersApi = {
  list: async (): Promise<Partner[]> => {
    const res = await apiClient.get<{ partners: Partner[] }>('/admin/partners');
    return res.data.partners;
  },

  getById: async (id: string): Promise<Partner> => {
    const res = await apiClient.get<Partner>(`/admin/partners/${id}`);
    return res.data;
  },

  create: async (payload: CreatePartnerPayload): Promise<Partner> => {
    const res = await apiClient.post<Partner>('/admin/partners', payload);
    return res.data;
  },

  update: async (id: string, payload: UpdatePartnerPayload): Promise<Partner> => {
    const res = await apiClient.patch<Partner>(`/admin/partners/${id}`, payload);
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/partners/${id}`);
  },

  getStats: async (id: string, params: PartnerStatsParams = {}): Promise<PartnerStats> => {
    const res = await apiClient.get<PartnerStats>(`/admin/partners/${id}/stats`, { params });
    return res.data;
  },
};
